<template>
  <div>
    <div v-if="previewUnavailable">
      <div class="preview-unavailable-container uk-inline">
        <div class="uk-position-center">
          <img class="preview-unavailable-icon" :data-src="previewUnavailableIcon" uk-img />
          <div class="preview-error">
            <p class="error-text">{{ $t('previewer.sorry') }}</p>
          </div>
        </div>
      </div>
      <div class="preview-unavailable-thumbnail-container"></div>
    </div>
    <div
      v-else
      id="slideshow"
      ref="slideshow"
      class="content-slideshow"
      :uk-slideshow="slideShowOptions"
      @itemshow="setActivityType"
    >
      <div class="inner-container-slideshow uk-position-relative uk-visible-toggle">
        <!--TODO: Uncomment Overlay for next prod push-->
        <!--<lab-overlay :activityType="activityType"></lab-overlay>-->
        <ul ref="slideShowList" class="uk-slideshow-items">
          <li class="uk-flex" v-for="(activityInfo, index) in activities" :key="index">
            <lesson-renderer
              :EUResource="EUResource"
              :activityInfo="activityInfo"
              :inFocus="inFocus(index)"
            ></lesson-renderer>
          </li>
        </ul>
        <a
          id="prev"
          class="left arrow uk-position-center-left uk-position-small uk-light"
          href="#"
          uk-slideshow-item="previous"
          @click="navigate(false)"
        >
          <div class="arrow-left">
            <img class="arrow-active" :src="combinedShape" />
            <img class="arrow-hover" :src="rightEnabled" />
          </div>
        </a>
        <a
          id="next"
          class="right arrow uk-position-center-right uk-position-small uk-light"
          href="#"
          uk-slideshow-item="next"
          @click="navigate(true)"
        >
          <div class="arrow-right">
            <img class="arrow-active" :src="combinedShape" />
            <img class="arrow-hover" :src="rightEnabled" />
          </div>
        </a>
      </div>
      <div
        ref="nav"
        class="thumbnail-slider uk-position-relative"
        uk-slider="sets: true; finite: true;"
      >
        <div class="thumbnail-slider-container">
          <div class="thumbnail-slider-inner-container uk-slider-container">
            <ul class="uk-slider-items">
              <li
                :class="{'active-slide': index === thumbnailSliderIndex}"
                class="add-pointer uk-overflow-hidden"
                @click="trackEvent"
                v-for="(activity, index) in activities"
                :uk-slideshow-item="index"
                :key="index"
              >
                <a href="#" @click="setActive(index)">
                  <thumbnailIcons
                    :deviceIcon="activity.collaboration"
                    :iconColor="activity.color"
                    :activityIcon="activity.icon"
                    :collaboration="activity.collaboration"
                  />
                  <span>
                    <div class="img-overlay"></div>
                    <img v-if="activity.thumbnailError" :data-src="thumbnailImageMissing" uk-img />
                    <img v-else :data-src="activity.preview" uk-img />
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <a
          class="left thumbnail-arrow uk-position-center-left uk-position-small uk-light"
          href="#"
          uk-slider-item="previous"
        >
          <div class="thumbnail-slider-arrow-left">
            <img class="arrow-active" :src="combinedShape" />
            <img class="arrow-hover" :src="rightEnabled" />
          </div>
        </a>
        <a
          class="right thumbnail-arrow uk-position-center-right uk-position-small uk-light"
          href="#"
          uk-slider-item="next"
        >
          <div class="thumbnail-slider-arrow-right">
            <img class="arrow-active" :src="combinedShape" />
            <img class="arrow-hover" :src="rightEnabled" />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import ComboAlert from '@/components/ui-components/alerts/combo-alert'
import SimpleAlert from '@/components/ui-components/alerts/simple-alert'
import lessonRenderer from './renderers/lesson-renderer'
import thumbnailIcons from './thumbnail-slider-icons'
import keypressUtil from '@/utils/keypress-util'
import UIkit from 'uikit'
import * as event from '@/enums/mixpanel-event'
import labOverlay from './lab/activity-type-overlay'
import * as _ from 'lodash'
import iconUtil from '@/utils/icon-util'
import * as misc from '@/enums/misc'
import screen from '@/utils/screen-util'
import touchUtil from '@/utils/touch-util'
import mixpanel from '@/services/mixpanel'

export default {
  name: 'previewer',
  components: {
    ComboAlert,
    SimpleAlert,
    labOverlay,
    lessonRenderer,
    thumbnailIcons
  },
  props: ['activities', 'EUResource', 'title'],
  data() {
    return {
      icon: 'icon: check',
      message: 'Response 2 Assessment',
      requiresDevice: 'Requires student device',
      deviceIcon: 'icon: phone',
      link: '#info-modal',
      linkText: 'how does it work?',
      buttonLink: 'target:#preview-modal',
      buttonText: 'Preview Questions',
      activityType: null,
      previewUnavailable: false,
      previewUnavailableIcon: iconUtil.resolve(misc.ERROR_ICON_PREVIEWER),
      thumbnailImageMissing: iconUtil.resolve(misc.IMAGE_NOT_FOUND_THUMBNAIL),
      combinedShape: iconUtil.resolve(misc.COMBINED_SHAPE),
      rightEnabled: iconUtil.resolve(misc.RIGHT_ENABLED),
      studentDevices: iconUtil.resolve(misc.STUDENT_DEVICES),
      thumbnailSliderIndex: 0,
      screenWidth: 0,
      slideShowOptions: `finite: true; ratio: 4:2; velocity:50; draggable: false`,
      draggable: true
    }
  },
  computed: {
    altDescription() {
      if (this.thumbnailSliderIndex === 0) {
        return this.title
      }
    }
  },
  methods: {
    resolveWindowWidth() {
      this.screenWidth = screen.resolveWidth()
    },
    setActive(index) {
      this.thumbnailSliderIndex = index
    },
    navigate(forward) {
      let slideshow = UIkit.slideshow(this.$refs.slideshow)
      let slider = UIkit.slider(this.$refs.nav)
      let index = slideshow.getIndex() // previous index
      if (!_.isUndefined(forward)) {
        index += forward ? 1 : -1
      }
      this.setActive(index)
      let setSize = 0
      if (this.screenWidth > 1600) {
        setSize =
          slider.sets.length < 6
            ? slider.length / slider.sets.length + 1
            : slider.length / slider.sets.length
      } else {
        setSize = slider.length / slider.sets.length
      }
      let setIndex = parseInt(index / setSize)
      slider.show(slider.sets[setIndex])
      this.trackEvent()
    },
    trackEvent() {
      mixpanel.track(event.BROWSING_RESOURCE_IMAGES, {
        contentId: this.$route.params.id
      })
    },
    touchNav() {
      let slideshow = UIkit.slideshow(this.$refs.slideshow)
      let slider = UIkit.slider(this.$refs.nav)
      let index = slideshow.getIndex() // previous index
      this.setActive(index)
      let setSize = 0
      if (this.screenWidth > 770 && this.screenWidth < 1024) {
        setSize =
          slider.sets.length < 6
            ? slider.length / slider.sets.length + 1
            : slider.length / slider.sets.length
      } else {
        setSize = slider.length / slider.sets.length
      }
      let setIndex = parseInt(index / setSize)
      slider.show(slider.sets[setIndex])
    },
    setActivityType() {
      if (!this.previewUnavailable) {
        let slideshow = UIkit.slideshow(this.$refs.slideshow)
        let index = slideshow.getIndex()
        this.activityType = this.activities[index].activityType
      }
    },
    inFocus(index) {
      return this.thumbnailSliderIndex === index
    }
  },
  mounted() {
    keypressUtil.registerListener(37, () => {
      document.getElementById('prev').click()
    })
    keypressUtil.registerListener(39, () => {
      document.getElementById('next').click()
    })
    this.$nextTick(() => {
      let el = this.$refs.slideShowList
      touchUtil.swipedetect(el, this.touchNav.bind(this))
    })
    this.previewUnavailable = _.isEmpty(this.activities)
    this.resolveWindowWidth()
    window.addEventListener('resize', this.resolveWindowWidth)
  },
  destroyed() {
    window.removeEventListener('resize', this.resolveWindowWidth)
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/colours.scss';
@import '../../styles/breakpoints';

.preview-unavailable-thumbnail-container {
  margin-top: 4px;
  height: 120px;
  background-color: $unavailable-container;
  width: 100%;
}

.preview-unavailable-container {
  padding-bottom: 50%;
  background-color: $unavailable-container;
  width: 100%;
}

.preview-unavailable-icon {
  padding-left: 144px;
}

.preview-error {
  width: 382px;
  height: 72px;
}

.error-text {
  font-size: 18px;
  font-weight: bold;
  color: rgba(0, 1, 2, 0.7);
  padding-top: 40px;
  text-align: center;
}

.content-slideshow {
  background-color: $slider-items-background-color;

  .inner-container-slideshow {
    border-radius: 2px;
    background-color: $slider-background-color !important;

    .arrow {
      .arrow-active {
        position: absolute;
        z-index: 2;
      }

      .arrow-hover {
        visibility: hidden;
        position: absolute;
        z-index: -2;
      }
    }

    .uk-invisible {
      .arrow-right {
        .arrow-hover {
          visibility: hidden !important;
        }
      }

      .thumbnail-slider-arrow-right {
        .arrow-hover {
          visibility: hidden !important;
        }
      }

      .arrow-left {
        .arrow-hover {
          visibility: hidden !important;
        }
      }

      .thumbnail-slider-arrow-left {
        .arrow-hover {
          visibility: hidden !important;
        }
      }
    }

    .right {
      .arrow-right {
        margin-top: -12px;
        position: relative;
        margin-right: -20px;

        .arrow-hover {
          margin-right: -5px;
        }
      }

      &:hover {
        .arrow-active {
          visibility: hidden;
          z-index: -2;
        }

        .arrow-hover {
          visibility: visible;
          z-index: 2;
          width: 10.57px;
        }
      }
    }

    .left {
      .arrow-left {
        margin-top: -12px;
        position: relative;
        margin-left: -20px;
        transform: rotate(0deg) scaleX(-1);
      }

      &:hover {
        .arrow-active {
          visibility: hidden;
          z-index: -2;
        }

        .arrow-hover {
          visibility: visible;
          z-index: 2;
          width: 10.57px;
        }
      }
    }
  }

  .uk-slideshow-items {
    width: 92%;
    margin: 0 4% 0 4%;
    background-color: $slider-items-background-color;
    border-radius: 2px;
  }
}

.thumbnail-slider {
  padding-top: 4px;

  .image-icon {
    z-index: -2;
    position: absolute;
  }

  .uk-slider-container {
    height: 120px;
    width: 92%;
    margin: 0 4% 0 4%;
  }

  .thumbnail-arrow {
    margin-top: 0px;

    .arrow-active {
      position: absolute;
      z-index: 2;
    }

    .arrow-hover {
      visibility: hidden;
      position: absolute;
      z-index: -2;
    }
  }

  .right {
    .thumbnail-slider-arrow-right {
      margin-top: 7px;
      position: relative;
      margin-right: -20px;
    }

    &:hover {
      .arrow-active {
        visibility: hidden;
        z-index: -2;
      }

      .arrow-hover {
        visibility: visible;
        z-index: 2;
        width: 10.57px;
      }
    }
  }

  .left {
    .thumbnail-slider-arrow-left {
      margin-top: 7px;
      position: relative;
      margin-left: -20px;
      transform: rotate(0deg) scaleX(-1);
    }

    &:hover {
      .arrow-active {
        visibility: hidden;
        z-index: -2;
      }

      .arrow-hover {
        visibility: visible;
        z-index: 2;
        width: 10.57px;
      }
    }
  }

  .active-slide {
    border: 4px solid $light-blue;
  }

  ul {
    margin-top: 2px;
  }

  .uk-slider-items {
    li {
      position: relative;
      width: 130px;
      height: 104px;
      display: block !important;
    }

    img {
      z-index: -1;
    }

    .active-slide {
      .img-overlay {
        background-color: #000000;
        opacity: 0;
      }
    }

    .img-overlay {
      position: absolute;
      width: 130px;
      height: 104px;
      z-index: 1;
      background-color: #000000;
      opacity: 0.15;
    }
  }
}

.thumbnail-slider-container {
  background-color: $thumbnail-slider-background-color !important;
  border-radius: 2px;
}

.uk-slideshow-items img {
  margin: auto;
  -ms-user-select: none; /* IE 10+ */
  -moz-user-select: none; /* Firefox all */
  -webkit-user-select: none; /* Chrome all / Safari all */
  user-select: none; /* Likely future */
}

@-webkit-keyframes PREVIEW-ANIMATION {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes PREVIEW-ANIMATION {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes PREVIEW-ANIMATION {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes PREVIEW-ANIMATION {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.uk-slider-items li {
  border: 5px solid $thumbnail-slider-background-color;
  border-radius: 2px;
}

.uk-slider-items {
  -webkit-animation: PREVIEW-ANIMATION 2s; /* Safari 4+ */
  -moz-animation: PREVIEW-ANIMATION 2s; /* Fx 5+ */
  -o-animation: PREVIEW-ANIMATION 2s; /* Opera 12+ */
  animation: PREVIEW-ANIMATION 2s; /* IE 10+, Fx 29+ */
}
</style>
